// extracted by mini-css-extract-plugin
export default {"container":"Faqs_container__DXwDz","display":"Faqs_display__HKaKM","hidden":"Faqs_hidden__NOLHb","faqs":"Faqs_faqs__PYxS1"};